module.exports = __webpack_public_path__ + "static/media/expired.5c1030b2.svg";